import React, { Component } from 'react';
import { connect } from 'react-redux'
import { DropTarget } from 'react-dnd';
import * as general from '../../constants/General'
import PropTypes from 'prop-types'

const dropTarget = {
};

function collect(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver()
    };
}

class ObjectItemDropTarget extends Component {
    render() {
        const { connectDropTarget } = this.props;

        return connectDropTarget(
            <div id="items">
                {this.props.children}
            </div>
        )
    }
}

ObjectItemDropTarget.propTypes = {
    rasterX: PropTypes.number,
    rasterY: PropTypes.number
}

function mapStateToProps(state) {
    return {
    }
}

ObjectItemDropTarget = DropTarget(general.DND_OJECTITEMBUTTON, dropTarget, collect)(ObjectItemDropTarget);
export default connect(mapStateToProps)(ObjectItemDropTarget)


// WEBPACK FOOTER //
// src/objectmanagement/components/ObjectItemDropTarget.jsx